import { render, staticRenderFns } from "./PermissionsUser.vue?vue&type=template&id=be3ce4f8&scoped=true&"
import script from "./PermissionsUser.vue?vue&type=script&lang=js&"
export * from "./PermissionsUser.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsUser.vue?vue&type=style&index=0&id=be3ce4f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3ce4f8",
  null
  
)

export default component.exports